import { CssBaseline } from '@mui/material'
import {
  type ThemeOptions,
  ThemeProvider as ThemeProviderMui
} from '@mui/material/styles'

import config from 'devextreme/core/config'
import type { PropsWithChildren } from 'react'
import { licenseKey } from './devextreme-license'

config({ licenseKey: licenseKey })

export const ThemeProvider = ({
  children,
  theme
}: PropsWithChildren<{ theme: ThemeOptions }>) => {
  return (
    <ThemeProviderMui theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProviderMui>
  )
}
